import { styled } from '@mui/material';
import { TABLE_HIERARCHY_COLORS } from '../../../enum';
import { TableCell, TableRow } from '../../common';
export var StyledLocationTypeRow = styled(TableRow)(function () {
  return {
    '& th, & td': {
      backgroundColor: "".concat(TABLE_HIERARCHY_COLORS.lightBlue, " !important")
    }
  };
});
export var StyledCountryRow = styled(TableRow)(function () {
  return {
    '& th, & td': {
      backgroundColor: "".concat(TABLE_HIERARCHY_COLORS.lightBlueGray, " !important")
    }
  };
});
export var StyledTotalRow = styled(TableRow)(function (_a) {
  var theme = _a.theme;
  return {
    '& th, & td': {
      backgroundColor: "".concat(theme.palette.primary.dark, " !important"),
      color: "".concat(theme.palette.primary.contrastText, " !important")
    }
  };
});
export var StyledSiteRow = styled(TableRow)(function () {
  return {
    '& th, & td': {
      backgroundColor: "".concat(TABLE_HIERARCHY_COLORS.lightGray, " !important")
    }
  };
});
export var StyledInputTableCell = styled(TableCell)(function () {
  return {
    minWidth: '6.4rem',
    backgroundColor: "".concat(TABLE_HIERARCHY_COLORS.white, " !important")
  };
});